import { productDB, pluckDocs } from '../helpers/db'
import { sortById, makeProductId, isValidProductId } from './id-handler'
import { findProduct } from './utils'

const ADD_PRODUCT_SUCCESS = 'products/ADD_PRODUCT_SUCCESS'
const ADD_PRODUCT_DUBPLICATE = 'products/ADD_PRODUCT_DUBPLICATE'
const ADD_PRODUCT_FAILURE = 'products/ADD_PRODUCT_FAILURE'
const UPDATE_PRODUCT_SUCCESS = 'products/UPDATE_PRODUCT_SUCCESS'
const UPDATE_PRODUCT_FAILURE = 'products/UPDATE_PRODUCT_FAILURE'
const UPDATE_PRODUCT = 'products/UPDATE_PRODUCT'
const UPDATE_INMEMORY_PRODUCT = 'products/UPDATE_INMEMORY_PRODUCT'
const BATCH_PRODUCT_UPDATE = 'products/BATCH_PRODUCT_UPDATE'
const PRODUCT_REQUEST_ONGOING = 'products/PRODUCT_REQUEST_ONGOING'
const PRODUCT_REQUEST_ENDED = 'products/PRODUCT_REQUEST_ENDED'
const CLEAR_INMEMORY_PRODUCT = 'products/CLEAR_INMEMORY_PRODUCT'
const CLEAR_SUCCESS_MESSAGE = 'products/CLEAR_SUCCESS_MESSAGE'

const defaultState = {
  products: [],
  inMemoryProduct: {},
  requestOngoing: false
}
export default (state = defaultState, { type, ...actionProps }) => {
  switch (type) {
    case ADD_PRODUCT_SUCCESS:
      return {
        ...state,
        successMsg: 'Product added successfully'
      }
    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        successMsg: 'Product updated successfully'
      }
    case CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        successMsg: ''
      }
    case UPDATE_PRODUCT_FAILURE:
    case ADD_PRODUCT_FAILURE:
      return {
        ...state,
        error: actionProps.error,
        successMsg: actionProps.error.reason
      }
    case ADD_PRODUCT_DUBPLICATE:
      const extraMessage = actionProps.product ? `${actionProps.product._id} - '${actionProps.product.name}'` : ''
      return {
        ...state,
        successMsg: 'Duplicate Product Name, Product already existing ' + extraMessage
      }
    case BATCH_PRODUCT_UPDATE:
    case UPDATE_PRODUCT:
      return {
        ...state,
        products: [...actionProps.data],
        requestOngoing: false
      }
    case UPDATE_INMEMORY_PRODUCT:
      return {
        ...state,
        inMemoryProduct: { ...actionProps.data }
      }
    case CLEAR_INMEMORY_PRODUCT:
      return {
        ...state,
        inMemoryProduct: {}
      }
    case PRODUCT_REQUEST_ONGOING:
      return {
        ...state,
        requestOngoing: true
      }
    case PRODUCT_REQUEST_ENDED:
      return {
        ...state,
        requestOngoing: false
      }
    default:
      return {
        ...state
      }
  }
}

/**
 * clear success message, just updating to ''
 */
export const clearSuccessMessage = () => (dispatch, getState) => {
  dispatch({
    type: CLEAR_SUCCESS_MESSAGE
  })
}

/**
 * Reset InMemoryLocation store
 */
export const resetInMemoryProduct = () => (dispatch, getState) => {
  dispatch({
    type: CLEAR_INMEMORY_PRODUCT
  })
}
/**
 * This is used to add price to a product.prices array and inturn save it directly to the
 * couchDB
 * @param {*} productId
 * @param {*} date
 * @param {*} price
 */
export const addPrice = (productId, date, price) => (dispatch, getState) => {
  let product = getState().products.products.filter(
    product => product._id === productId
  )[0]
  product.prices = product.prices || []
  product.prices.push({ date, price })
  const saveReducer = saveProduct(product) // since this is using closure to return the actual reducer
  saveReducer(dispatch, getState)
}

export const updateProduct = patch => (dispatch, getState) => {
  const tempProduct = getState().products.inMemoryProduct
  dispatch({
    type: UPDATE_INMEMORY_PRODUCT,
    data: { ...tempProduct, ...patch }
  })
}
/**
 * This is used to check if a product exist or not
 * @param arr list to check the product against using the _id of the product
 * @param product to check if existing in arr
 *
 * @return boolean
 */
const isProductExisting = (arr, product) => {
  return arr.find(item => item._id === product._id) || (findProduct(arr, product.name, {lookBehind: true}))
}

export const saveProduct = product => (dispatch, getState) => {
  const productList = [...getState().products.products]

  // dispatch something is going on with the product
  dispatch({
    type: PRODUCT_REQUEST_ONGOING
  })
  let newProduct = product // use same object just incase its not for new product, so we maintain same reference
  let action = {}
  if (!isValidProductId(newProduct._id)) {
    // means this is a new product
    newProduct = { ...product, _id: makeProductId(product._id) }

    const existingProduct = isProductExisting(productList, newProduct)
    if (existingProduct) {
      dispatch({
        type: ADD_PRODUCT_DUBPLICATE,
        product: existingProduct
      })
      dispatch({
        type: PRODUCT_REQUEST_ENDED
      })
      return
    } else {
      productList.push(newProduct)
    }

    action = {
      type: UPDATE_PRODUCT,
      data: sortById(productList)
    }
  }
  productDB
    .put(newProduct)
    .then(response => {
      newProduct._rev = response.rev // update the object reference here
      if (action.type) {
        dispatch(action)
      }
      dispatch({
        type: ADD_PRODUCT_SUCCESS
      })
      dispatch({
        type: PRODUCT_REQUEST_ENDED
      })
    })
    .catch(e => {
      dispatch({
        type: ADD_PRODUCT_FAILURE,
        error: e
      })
      dispatch({
        type: PRODUCT_REQUEST_ENDED
      })
    })
}

export const fetchProducts = () => dispatch => {
  dispatch({
    type: PRODUCT_REQUEST_ONGOING
  })
  return productDB
    .allDocs({
      include_docs: true
    })
    .then(pluckDocs)
    .then(products => {
      dispatch({
        type: BATCH_PRODUCT_UPDATE,
        data: sortById(products)
      })
    })
    .catch(() => {
      dispatch({
        type: PRODUCT_REQUEST_ENDED
      })
    })
}

export const saveOldProduct = product => (dispatch, getState) => {
  const state = getState()
  const products = state.products.products
  const updatedBy = state.auth.user.name
  const updatedAt = new Date().toISOString()

  // dispatch something is going on with the product
  dispatch({
    type: PRODUCT_REQUEST_ONGOING
  })

  // get old name
  const productIndex = products.findIndex(p => p._id === product._id)

  if (!product.oldNames) {
    product.oldNames = []
  }

  // validate if the product new name is not used as a ref in another product
  // https://github.com/fielded/van-orga/issues/2274
  const productCheck = findProduct(products, product.name, {lookBehind: true})
  if (productCheck && productCheck._id !== product._id) { // if it's not same id, it means the product is different and ref'ed somewhere else
    dispatch({
      type: ADD_PRODUCT_DUBPLICATE,
      product: productCheck
    })
    dispatch({
      type: PRODUCT_REQUEST_ENDED
    })
    return
  }

  product.oldNames.push({name: products[productIndex].name, updatedAt, updatedBy})

  productDB.put(product)
    .then(response => {
      product._rev = response.rev // update the object reference here
      products[productIndex] = product
      dispatch({
        type: UPDATE_PRODUCT,
        data: sortById(products)
      })
      dispatch({
        type: UPDATE_PRODUCT_SUCCESS
      })
      dispatch({
        type: PRODUCT_REQUEST_ENDED
      })
    })
    .catch(e => {
      dispatch({
        type: UPDATE_PRODUCT_FAILURE,
        error: e
      })
      dispatch({
        type: PRODUCT_REQUEST_ENDED
      })
    })
}



// WEBPACK FOOTER //
// ./src/products/products-reducer.js